var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.3184,
    height: 64.3184,
    rx: 32.1592,
    fill: "#25BC52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1591 19.5C25.1979 19.5 19.5024 25.1955 19.5024 32.1567C19.5024 39.1179 25.1979 44.8134 32.1591 44.8134C39.1203 44.8134 44.8158 39.1179 44.8158 32.1567C44.8158 25.1955 39.1203 19.5 32.1591 19.5ZM32.1591 42.282C26.5775 42.282 22.0338 37.7383 22.0338 32.1567C22.0338 26.5751 26.5775 22.0313 32.1591 22.0313C37.7407 22.0313 42.2845 26.5751 42.2845 32.1567C42.2845 37.7383 37.7407 42.282 32.1591 42.282ZM37.9685 26.5624L29.6278 34.9032L26.3497 31.6378L24.5651 33.4224L29.6278 38.485L39.7531 28.3597L37.9685 26.5624Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success-tick.806ff27542b497efa138688ea79b82d4.svg";
export { ForwardRef as ReactComponent };